import React from 'react';
import ProductImageFormatter from '@afosto/utils-react/formatters/ProductImageFormatter';
import ProductSkuFormatter from '@afosto/utils-react/formatters/ProductSkuFormatter';

export const productImageFormatter = (cell, row) => <ProductImageFormatter sku={row?.sku} />;

export const productSkuFormatter = cell => <ProductSkuFormatter sku={cell} />;

export default productImageFormatter;
